// extracted by mini-css-extract-plugin
export default {"Center":"Confirmation_Center__tGe4o"};